import React from 'react';
import { isEmpty, map } from 'lodash';
import classnames from 'classnames';
import ExpandIcon from './icons/ExpandIcon';
import CollapseIcon from './icons/CollapseIcon';
import RecipeTypeTransformsIcon from './icons/RecipeTypeTransformsIcon';
import RecipeTypeTransformsCodeIcon from './icons/RecipeTypeTransformsCodeIcon';
import RecipeTypeTransformsReplicateIcon from './icons/RecipeTypeTransformsReplicateIcon';
import RecipeTypeDefaultsIcon from './icons/RecipeTypeDefaultsIcon';
import RecipeTypeFiltersIcon from './icons/RecipeTypeFiltersIcon';
import RecipeTypeValidationsIcon from './icons/RecipeTypeValidationsIcon';
import RecipeTypeAnnotationsIcon from './icons/RecipeTypeAnnotationsIcon';
import {
  RECIPE_GROUP_ANNOTATIONS,
  RECIPE_GROUP_DEFAULTS,
  RECIPE_GROUP_FILTERS,
  RECIPE_GROUP_TRANSFORMS,
  RECIPE_GROUP_TRANSFORMS_AGGREGATE,
  RECIPE_GROUP_TRANSFORMS_CODE,
  RECIPE_GROUP_TRANSFORMS_REPLICATE,
  RECIPE_GROUP_VALIDATIONS,
} from 'js/constants/schemaEditor';
import RecipeTypeTransformsAggregateIcon from './icons/RecipeTypeTransformsAggregateIcon';

/**
 * @typedef {Object} RecipeBuilderSuggestionsProps
 * @property {boolean} isExpanded
 * @property {Array<Object>} suggestions
 * @property {Function} onToggleExpand
 * @property {Function} onSuggestionClicked
 * @property {React.ReactNode} recommendationItemOnTop // render a custom recommendation item on top of the list
 */
class RecipeBuilderSuggestions extends React.PureComponent {
  render() {
    const { isExpanded } = this.props;

    return (
      <div
        className={classnames('recipe-builder-recommendations', {
          'is-expanded': isExpanded,
        })}
      >
        <div className="recipe-builder-recommendations-header" onClick={this._handleHeaderClicked}>
          Recommendations
          {isExpanded ? <ExpandIcon /> : <CollapseIcon />}
        </div>
        {isExpanded && (
          <div className="recipe-builder-recommendations-content">
            {this._renderExpandedContent()}
          </div>
        )}
      </div>
    );
  }

  _renderExpandedContent = () => {
    const { suggestions, onSuggestionClicked } = this.props;

    if (isEmpty(suggestions)) {
      return 'No recommendations found.';
    }

    const listOfRecommendations = map(suggestions, (suggestion, index) => (
      <div
        key={index}
        className="recipe-builder-recommendation"
        onClick={() => onSuggestionClicked(suggestion.recipeGroup)}
      >
        <div className="icon">{this._getRecipeTypeIcon(suggestion.recipeGroup.type)}</div>
        {suggestion.content}
      </div>
    ));

    if (this.props?.recommendationItemOnTop) {
      return (
        <>
          {this.props.recommendationItemOnTop}
          {listOfRecommendations}
        </>
      );
    }

    return listOfRecommendations;
  };

  _getRecipeTypeIcon = (type) => {
    switch (type) {
      case RECIPE_GROUP_TRANSFORMS:
        return <RecipeTypeTransformsIcon />;

      case RECIPE_GROUP_TRANSFORMS_CODE:
        return <RecipeTypeTransformsCodeIcon />;

      case RECIPE_GROUP_TRANSFORMS_AGGREGATE:
        return <RecipeTypeTransformsAggregateIcon />;

      case RECIPE_GROUP_TRANSFORMS_REPLICATE:
        return <RecipeTypeTransformsReplicateIcon />;

      case RECIPE_GROUP_DEFAULTS:
        return <RecipeTypeDefaultsIcon />;

      case RECIPE_GROUP_FILTERS:
        return <RecipeTypeFiltersIcon />;

      case RECIPE_GROUP_VALIDATIONS:
        return <RecipeTypeValidationsIcon />;

      case RECIPE_GROUP_ANNOTATIONS:
        return <RecipeTypeAnnotationsIcon />;

      default:
        return null;
    }
  };

  _handleHeaderClicked = () => {
    this.props.onToggleExpand();
  };
}

export default RecipeBuilderSuggestions;
